import { memo, useCallback, useState } from 'react';
import { CustomTableCell, linkStyle } from '../../styles';
import { EntryToolTip } from '../../../../components/snackBar/toolTip';
import JournalToolTip from '../../../../components/modals/JournalToolTip';
import { TRANSACTION_CONFIG } from '../../../../utils/common';
import { useDispatch } from 'react-redux';
import { updateTitle } from '../../../../redux/reducers/titleSlice';

const CustomTableCellForAccount = memo(({ accountDetails, data, onClick = () => {}, sx = {} }) => {
  let style = linkStyle;
  let AccountName = data.oppositeaccountname;
  if (data.transactiontype == 'OpeningBalance') {
    AccountName = 'Opening Balance';
    style = {};
    onClick = () => {};
  }
  const [modalJournalTransID, setModalJournalTransID] = useState('');
  const mergedSx = { ...style, ...sx };
  if (data.transactiontype == 'OpeningBalance') {
    return (
      <CustomTableCell sx={mergedSx}>
        <span className="">{AccountName}</span>
      </CustomTableCell>
    );
  } else {
    return (
      <CustomTableCell sx={mergedSx} onClick={onClick}>
        <EntryToolTip
          value={data.transactionid}
          onOpen={(e) => {
            setModalJournalTransID(data.transactionid);
          }}
          title={
            <>
              <JournalToolTip journalTransID={modalJournalTransID} accountDetails={accountDetails} />
            </>
          }
        >
          <a onClick={(e) => e.preventDefault()} href={`/LedgerTransactions/${data.oppositeaccountid}`} className="myLink">
            {AccountName}
          </a>
        </EntryToolTip>
      </CustomTableCell>
    );
  }
});
const CustomTableCellRedirectToVoucher = memo(({ data, type, children, sx = {} }) => {
  console.log(data, 'datahhhhhh');
  console.log(type, 'type');
  const dispatch = useDispatch();
  const config = TRANSACTION_CONFIG[type] || {
    path: '',
    getTransactionId: () => '',
  };
  const { path, getTransactionId } = config;
  const link = path ? `/${path}/${data.vouchernumber}?transaction=${getTransactionId(data)}` : '';
  const handleClick = useCallback(
    (e) => {
      // dispatch(
      //     updateTitle(data.vouchernumber)
      // );
      e.preventDefault();
      if (path) {
        window.open(link);
        dispatch(updateTitle(data.vouchernumber));
      }
    },
    [path, link]
  );

  return (
    <CustomTableCell sx={sx}>
      <a className="myLink" href={link} onClick={handleClick}>
        {children}
      </a>
    </CustomTableCell>
  );
});

export { CustomTableCellForAccount, CustomTableCellRedirectToVoucher };
